export enum ScanCheckDecisionType {
  CardItem,
  ConsultantItem,
  DoNotMigrate,
}
